import React, { useCallback } from "react";

import { Modal, Platform } from "react-native";

import { WebModal } from "@/src/TopLevelNavigators/UserLoggedIn/WebModal";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";

type Props = {
  onSelectOccasion: (sequenceNumber: number) => void;
  onClose: () => void;
  isOpen: boolean;
  children: (props: {
    selectSequence: (num: number) => void;
    onCloseOccasion(): void;
  }) => React.ReactNode;
};

const RoutineOccasionHistoryModalContainer_ = (props: Props) => {
  const selectSequence = useCallback(
    (num: number) => {
      props.onSelectOccasion(num);
    },
    [props]
  );

  const onCloseOccasion = useCallback(() => {
    props.onClose();
  }, [props]);

  if (!props.isOpen) {
    return null;
  }

  return (
    <M visible={props.isOpen} onRequestClose={onCloseOccasion}>
      <SafeAreaProvider>
        <SafeAreaView style={{ flex: 1 }}>
          {props.children({ selectSequence, onCloseOccasion })}
        </SafeAreaView>
      </SafeAreaProvider>
    </M>
  );
};

export const RoutineOccasionHistoryModalContainer = React.memo(
  RoutineOccasionHistoryModalContainer_
);
function M(props: {
  children: React.ReactNode;
  visible: boolean;
  onRequestClose: () => void;
}) {
  if (Platform.OS === "web") {
    return props.visible ? (
      <WebModal dismissable onRequestClose={props.onRequestClose}>
        {props.children}
      </WebModal>
    ) : null;
  }

  return (
    <Modal
      visible={props.visible}
      presentationStyle="formSheet"
      animationType="slide"
      onRequestClose={props.onRequestClose}
      style={{ flex: 1 }}
    >
      {props.children}
    </Modal>
  );
}
